import { Segment, Icon } from "semantic-ui-react";

const AssetStatusInfo = ({ assetStatusData }) => {
  const capStatuses = ["approved", "pending", "rejected", "partially_rejected"];
  const { assetStatus, assetMetaData, assetKey } = assetStatusData;
  const messageType = {
    icon: {
      name:
        assetStatus === "qc_ok" || assetStatus === "approved" || assetStatus === "zip_ok"
          ? "checkmark"
          : assetStatus === "qc_caution" ||
            assetStatus === "pending" ||
            assetStatus === "partially_rejected"
          ? "warning sign"
          : "exclamation",
      color:
        assetStatus === "qc_ok" || assetStatus === "approved" || assetStatus === "zip_ok"
          ? "#15742b"
          : assetStatus === "qc_caution" || assetStatus === "pending"
          ? "#ffa700"
          : "white",
      fontSize: assetStatus !== "qc_caution" ? "1.25rem" : "2.25rem",
    },
  };
  return (
    <Segment key={assetKey} className={`asset-status ${assetStatus}`}>
      <div className="icon-background">
        <Icon
          style={{
            fontSize: messageType.icon.fontSize,
            color: `${messageType.icon.color}`,
          }}
          name={`${messageType.icon.name}`}
        />
      </div>
      <p>{capStatuses.includes(assetStatus) ? assetStatus.replace("_", " ") : assetMetaData}</p>
    </Segment>
  );
};

export default AssetStatusInfo;
